import React, { FC, useEffect, useRef, useState } from 'react'
import { LinkStatusFilterValue, UserStatuses } from '../../helpers/constants'
import {
  ChevronWrap,
  FilterButton,
  FilterContainer,
  Menu,
  MenuItem,
} from './InvitationStatusFilter.styles'

export type InvitationStatusFilterValue = LinkStatusFilterValue

const options: { label: string, value: InvitationStatusFilterValue }[] = [
  { label: 'All invitations', value: 'ALL' },
  { label: 'Pending invitation', value: UserStatuses.SENT },
  { label: 'Invitation link expired', value: UserStatuses.EXPIRED },
]

const ChevronIcon = () => (
  <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

interface Props {
  value: InvitationStatusFilterValue
  onChange: (value: InvitationStatusFilterValue) => void
}

export const InvitationStatusFilter: FC<Props> = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const selectOptionHandler = (option: InvitationStatusFilterValue) => {
    onChange(option)
    setIsOpen(false)
  }

  const selectedLabel = options.find(option => option.value === value)?.label || 'Invitation status'

  return (
    <FilterContainer ref={containerRef}>
      <FilterButton onClick={() => setIsOpen(prevState => !prevState)}>
        {selectedLabel}
        <ChevronWrap isOpen={isOpen}>
          <ChevronIcon />
        </ChevronWrap>
      </FilterButton>
      {isOpen && (
        <Menu>
          {options.map(option => (
            <MenuItem
              key={option.value}
              isSelected={option.value === value}
              onClick={() => selectOptionHandler(option.value)}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </FilterContainer>
  )
}
